import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { COMPANY, SERVIZI, SETTORI } from "@/data/content";
import { useConsent } from "@/components/consent/ConsentProvider";

export function Footer() {
  const { openPreferences } = useConsent();
  return (
    <footer data-testid="site-footer" className="bg-[#0A1F2E] text-white/80 grain">
      <div className="container-x py-20 sm:py-28 grid gap-14 md:grid-cols-12">
        <div className="md:col-span-5">
          <img
            src="/xl-brokers-logo.png"
            alt="XL Brokers"
            className="h-14 w-auto object-contain"
            draggable="false"
          />
          <p className="mt-8 max-w-md text-sm text-white/65 leading-relaxed">
            Brokeraggio assicurativo indipendente. Costruiamo programmi su misura per PMI, professionisti e famiglie con un
            approccio sartoriale e trasparente.
          </p>
          <div className="mt-8 space-y-2 text-sm">
            <p className="text-white/60">{COMPANY.address}</p>
            <p>
              <a href={`tel:${COMPANY.phone}`} className="underline-link" data-testid="footer-phone">
                {COMPANY.phone}
              </a>
            </p>
            <p>
              <a href={`mailto:${COMPANY.email}`} className="underline-link" data-testid="footer-email">
                {COMPANY.email}
              </a>
            </p>
            <p className="text-white/55">PEC: {COMPANY.pec}</p>
          </div>
        </div>

        <div className="md:col-span-3">
          <p className="text-xs uppercase tracking-[0.32em] font-semibold text-[#89E877] mb-5">Servizi</p>
          <ul className="space-y-3 text-sm">
            {SERVIZI.map((s) => (
              <li key={s.slug}>
                <Link to={`/servizi#${s.slug}`} className="underline-link text-white/80 hover:text-white">
                  {s.title}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-4">
          <p className="text-xs uppercase tracking-[0.32em] font-semibold text-[#89E877] mb-5">Settori</p>
          <ul className="grid grid-cols-1 gap-3 text-sm">
            {SETTORI.map((s) => (
              <li key={s.slug}>
                <Link to={`/settori/${s.slug}`} className="underline-link text-white/80 hover:text-white">
                  {s.title}
                </Link>
              </li>
            ))}
            <li className="pt-4 mt-2 border-t border-white/10">
              <Link to="/assistart" className="underline-link text-white/80 hover:text-white inline-flex items-center gap-2" data-testid="footer-assistart">
                <span className="h-1.5 w-1.5 rounded-full bg-[#89E877]" /> Assistart · Podcast
              </Link>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="container-x py-8 flex flex-col md:flex-row items-start md:items-center gap-4 justify-between text-xs text-white/55">
          <p>
            © {new Date().getFullYear()} {COMPANY.legalName} — {COMPANY.vat} — Iscritta al RUI {COMPANY.ruiSection} n.{" "}
            <a className="underline" href={COMPANY.ruiUrl} target="_blank" rel="noreferrer">
              {COMPANY.rui}
            </a>
            . Broker di assicurazioni soggetto al controllo dell'IVASS.
          </p>
          <div className="flex flex-wrap gap-x-6 gap-y-2">
            <Link to="/informazioni-intermediario" className="underline-link" data-testid="footer-link-info-intermediario">Informazioni Intermediario</Link>
            <Link to="/reclami" className="underline-link" data-testid="footer-link-reclami">Reclami</Link>
            <Link to="/privacy" className="underline-link" data-testid="footer-link-privacy">Privacy</Link>
            <Link to="/cookie" className="underline-link" data-testid="footer-link-cookie">Cookie</Link>
            <button
              type="button"
              onClick={openPreferences}
              className="underline-link text-left"
              data-testid="footer-link-manage-consent"
            >
              Gestisci consenso
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}
